import { render, staticRenderFns } from "./RHEscolaridades.vue?vue&type=template&id=7a010903&scoped=true"
import script from "./RHEscolaridades.vue?vue&type=script&lang=js"
export * from "./RHEscolaridades.vue?vue&type=script&lang=js"
import style0 from "./RHEscolaridades.vue?vue&type=style&index=0&id=7a010903&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a010903",
  null
  
)

export default component.exports